/* global axios */
import ApiClient from './ApiClient';

class AiAgentRunsAPI extends ApiClient {
  constructor() {
    super('ai/runs', { accountScoped: true, apiVersion: 'v2' });
  }

  index({ agentId, page = 1, perPage = 25 } = {}) {
    return axios.get(this.url, {
      params: {
        ai_agent_id: agentId,
        page,
        per_page: perPage,
      },
    });
  }
}

export default new AiAgentRunsAPI();
